import { cva, type VariantProps } from "class-variance-authority";
import type { FC } from "react";
import { Icon } from "../icons/icons";
import { cn } from "../utils";

/** Props Interface */
export interface SpinnerProps extends VariantProps<typeof spinner> {
	size?: 5 | 10 | 15 | 20 | 25 | 30 | 35 | 40;
}

export const Spinner: FC<SpinnerProps> = ({ size = 15, color }) => {
	const classes = spinner({ color });

	/** Render */
	return (
		<Icon
			name="Loader"
			className={cn("animate-spin", classes)}
			size={size}
		/>
	);
};

const spinner = cva([], {
	variants: {
		color: {
			primary: ["stroke-primary-500"],
			white: ["stroke-white"],
			black: ["stroke-black"],
		},
	},
	defaultVariants: {
		color: "primary",
	},
});
